var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"footer",class:_vm.$route.name},[_vm._v("厦门知展科技有限公司版权所有 "),_c('a',{attrs:{"href":"http://www.beian.miit.gov.cn/","target":"_blank"}},[_vm._v("2020 闽ICP备11026771号-2")]),_c('div',{staticClass:"qrcode"})])}
var staticRenderFns = []

export { render, staticRenderFns }